module.exports = __webpack_public_path__ + "media/images/logos/windeurope-tech2023-cb4bfd731581bd1428a16fcb1e5fe147.svg";